import { z } from 'zod'
import { Timestamp } from './common'

/** A bike on the rider's Strava account, for mapping to a Klunkers bike. */
export const StravaBike = z.object({
  id: z.string(),
  name: z.string(),
  distance_m: z.number().nullable(),
  retired: z.boolean(),
})
export type StravaBike = z.infer<typeof StravaBike>

/** GET /strava/status. `configured` is false when this server has no Strava app set up. */
export const StravaStatus = z.object({
  configured: z.boolean(),
  connected: z.boolean(),
  athlete_name: z.string().nullable(),
  bikes: z.array(StravaBike),
  connected_at: Timestamp.nullable(),
  last_synced_at: Timestamp.nullable(),
  sync_state: z.enum(['idle', 'syncing', 'failed']).nullable(),
  sync_error: z.string().nullable(),
})
export type StravaStatus = z.infer<typeof StravaStatus>

/** POST /strava/connect: where to send the rider to approve Klunkers on Strava. */
export const StravaConnectResponse = z.object({ url: z.string() })
export type StravaConnectResponse = z.infer<typeof StravaConnectResponse>

/** PUT /bikes/:id/strava-gear. Null unmaps the bike. */
export const SetStravaGearBody = z.object({ gear_id: z.string().min(1).max(64).nullable() })
export type SetStravaGearBody = z.infer<typeof SetStravaGearBody>
